var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.profile != null && _vm.profileIndicatorsMeta.length > 0
        ? _c(
            "v-navigation-drawer",
            {
              style: { marginTop: _vm.marginTop + "px", overflow: "hidden" },
              attrs: {
                id: "fact-sheet-drawer",
                floating: "",
                right: "",
                temporary: "",
                stateless: "",
                "hide-overlay": "",
                app: "",
                width: _vm.factSheetWidth
              },
              model: {
                value: _vm.showFactSheet,
                callback: function($$v) {
                  _vm.showFactSheet = $$v
                },
                expression: "showFactSheet"
              }
            },
            [
              _c(
                "v-container",
                { attrs: { "pa-0": "", "pt-2": "", fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "no-grow",
                      attrs: { row: "", "justify-start": "", "align-start": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-card",
                            {
                              attrs: {
                                id: "basic-fact-sheet-container",
                                flat: "",
                                width: "300",
                                height: _vm.height,
                                "max-height": _vm.height
                              }
                            },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass: "fact-sheet-list",
                                  attrs: { dense: "", flat: "" }
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    { staticClass: "fact-sheet-header" },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            [
                                              _c(
                                                "v-tooltip",
                                                { attrs: { bottom: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "activator"
                                                      },
                                                      slot: "activator"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.profileHeader
                                                            .title
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.profileHeader.title
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.profileHeader.subtitle !== null
                                            ? _c(
                                                "v-list-tile-sub-title",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    { attrs: { bottom: "" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "activator"
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.profileHeader
                                                                .subtitle
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.profileHeader
                                                              .subtitle
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.showExtended === false
                                        ? _c(
                                            "v-list-tile-action",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.showFactSheet = false
                                                  _vm.showGeneralInfo = true
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                { attrs: { icon: "" } },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("close")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-subheader", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.profileHeader.yearInfo) +
                                        "\n                " +
                                        _vm._s(
                                          _vm.profileHeader.complementInfo
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group",
                                    {
                                      model: {
                                        value: _vm.showGeneralInfo,
                                        callback: function($$v) {
                                          _vm.showGeneralInfo = $$v
                                        },
                                        expression: "showGeneralInfo"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            ripple: ""
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.generalInfo.title
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("fact-sheet-generalinfo", {
                                        attrs: { data: _vm.generalInfo.data }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group",
                                    {
                                      ref: "publicOrgsList",
                                      staticClass: "clickable-group",
                                      attrs: { lazy: "" },
                                      model: {
                                        value: _vm.showPublicOrgs,
                                        callback: function($$v) {
                                          _vm.showPublicOrgs = $$v
                                        },
                                        expression: "showPublicOrgs"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.topPublicOrgs.title
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("fact-sheet-actors", {
                                        attrs: {
                                          "active-actors":
                                            _vm.selectedPublicOrgs,
                                          "max-height":
                                            _vm.publicOrgsListHeight,
                                          "progress-active":
                                            _vm.publicOrgsCount > 0,
                                          "progress-indeterminate":
                                            _vm.publicOrgsProgressBar,
                                          "prog-bar-height": _vm.progBarHeight
                                        },
                                        on: {
                                          "click:actor": function($event) {
                                            return _vm.switchPublicOrgsIndicator(
                                              $event
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var actor = ref.actor
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: actor.actorId,
                                                    class: {
                                                      secondary:
                                                        actor.actorId ===
                                                        _vm.extendedId
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showExtended = true
                                                        _vm.displayItemDetails(
                                                          actor.actorId,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      {
                                                        staticClass:
                                                          "actor-rank"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(actor.rank) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        actor.labelAlt !== null
                                                          ? _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    actor.labelAlt
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    actor.label
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-action", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(actor.value) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3129337106
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group",
                                    {
                                      ref: "firmsList",
                                      staticClass: "clickable-group",
                                      attrs: { lazy: "" },
                                      model: {
                                        value: _vm.showFirms,
                                        callback: function($$v) {
                                          _vm.showFirms = $$v
                                        },
                                        expression: "showFirms"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          attrs: { slot: "activator" },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.topFirms.title) +
                                                    "\n                    "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("fact-sheet-actors", {
                                        attrs: {
                                          "active-actors": _vm.selectedFirms,
                                          "max-height": _vm.firmsListHeight,
                                          "progress-active": _vm.firmsCount > 0,
                                          "progress-indeterminate":
                                            _vm.firmsProgressBar,
                                          "prog-bar-height": _vm.progBarHeight
                                        },
                                        on: {
                                          "click:actor": function($event) {
                                            return _vm.switchFirmsIndicator(
                                              $event
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var actor = ref.actor
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: actor.actorId,
                                                    class: {
                                                      secondary:
                                                        actor.actorId ===
                                                        _vm.extendedId
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showExtended = true
                                                        _vm.displayItemDetails(
                                                          actor.actorId,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      {
                                                        staticClass:
                                                          "actor-rank"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(actor.rank) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        actor.labelAlt !== null
                                                          ? _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    actor.labelAlt
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    actor.label
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-action", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(actor.value) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3129337106
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group",
                                    {
                                      ref: "sipList",
                                      staticClass: "clickable-group",
                                      attrs: {
                                        lazy: "",
                                        disabled:
                                          _vm.sipCount === 0 &&
                                          _vm.showSip === false
                                      },
                                      model: {
                                        value: _vm.showSip,
                                        callback: function($$v) {
                                          _vm.showSip = $$v
                                        },
                                        expression: "showSip"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            inactive: _vm.sipCount === 0,
                                            disabled: _vm.sipCount === 0
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.siProjects.title
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("fact-sheet-sip", {
                                        attrs: {
                                          data: _vm.siProjects.data,
                                          "max-height": _vm.sipListHeight,
                                          "progress-active": _vm.sipCount !== 0,
                                          "progress-indeterminate":
                                            _vm.sipProgressBar,
                                          "prog-bar-height": _vm.progBarHeight
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var tile = ref.tile
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: tile.sip_id,
                                                    class: {
                                                      secondary:
                                                        tile.sip_id ===
                                                        _vm.extendedId
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.sipCount === 0,
                                                      inactive:
                                                        _vm.sipCount === 0
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showExtended = true
                                                        _vm.displayItemDetails(
                                                          tile.sip_id,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(tile.label)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1024017925
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { attrs: { vertical: "" } }),
                      _vm._v(" "),
                      _vm.showExtended
                        ? _c(
                            "fact-sheet-extended",
                            {
                              attrs: {
                                "item-id": _vm.extendedId,
                                width: _vm.factSheetWidth - 300,
                                height: _vm.height
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "close-extended" },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.showExtended = false
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        { attrs: { icon: "" } },
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38495e5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38495e5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FactSheet.vue
// module id = null
// module chunks = 